/** @flow */
import * as React from 'react';
import Up from 'material-ui/svg-icons/action/trending-up';
import Down from 'material-ui/svg-icons/action/trending-down';
import styled, { withTheme } from 'styled-components';

import { Percent } from './Number';

type IconSize = {
  height: number;
  width: number;
};

type Props = {
  percent: number;
  style?: Object;
  iconSize?: IconSize;
  textStyle?: Object;
  colors?: Object;
  theme: Object;
}

const DivContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Text = styled.span`
  margin-left: ${({ theme }) => theme.metrics.tinyMargin}px;
`;

const defaultIconSize = {
  width: 40,
  height: 40,
};

const renderIcon = (percent: number, iconSize: IconSize, colors: Object) => {
  let Icon;
  let color;

  if (percent >= 0) {
    Icon = Up;
    color = colors.increaseStats;
  } else {
    Icon = Down;
    color = colors.decreaseStats;
  }

  return <Icon color={color} style={iconSize} />;
};

function IncreaseDecreasePercent({ percent, style, iconSize, textStyle, theme }: Props) {
  const defaultStyle = {
    fontSize: theme.fonts.style.secondary.fontSize,
  };

  const size = { ...defaultIconSize, ...iconSize };
  return (
    <DivContainer style={{ ...defaultStyle, ...style }}>
      {renderIcon(percent, size, theme.colors)}
      <Text percent={percent} style={{ ...textStyle, color: percent >= 0 ? theme.colors.increaseStats : theme.colors.decreaseStats }}>
        <Percent value={Math.abs(percent)} roundAt={2} />
      </Text>
    </DivContainer>
  );
}

export default withTheme(IncreaseDecreasePercent);



// WEBPACK FOOTER //
// ./src/common/components/IncreaseDecreasePercent.js